import { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { Copy, Loader2, MessageSquareReply } from "lucide-react";
import { api, errMsg, TONES } from "@/lib/api";
import { PageHeader, Panel } from "@/components/Shared";
import { Field, Select, Segmented, areaCls, inputCls, btnPrimary } from "@/components/Form";

export default function PublicReply() {
  const [stores, setStores] = useState([]);
  const [f, setF] = useState({ review_text: "", tone: "profissional", rating: "", store_id: "" });
  const [reply, setReply] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/stores").then((r) => setStores(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const storeOpts = useMemo(() => ({ "": "—", ...Object.fromEntries(stores.map((s) => [s.store_id, s.name])) }), [stores]);

  const gen = async () => {
    if (!f.review_text.trim()) return toast.error("Cole a avaliação do cliente.");
    setBusy(true);
    try {
      const { data } = await api.post("/public-reply", { ...f, rating: f.rating ? Number(f.rating) : null, store_id: f.store_id || null });
      setReply(data.reply);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="fade-up">
      <PageHeader eyebrow="Reputação" title="Respostas públicas" desc="Responda avaliações protegendo a reputação da loja, sem expor dados pessoais e sem acusações." />
      <div className="grid gap-6 lg:grid-cols-2">
        <Panel title="Avaliação do cliente" icon={MessageSquareReply}>
          <div className="space-y-4">
            <Field label="Texto da avaliação"><textarea data-testid="reply-review-input" rows={5} className={areaCls} value={f.review_text} onChange={(e) => setF({ ...f, review_text: e.target.value })} placeholder="Cole aqui o comentário do cliente" /></Field>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Nota (1-5)"><input data-testid="reply-rating-input" type="number" min="1" max="5" className={inputCls} value={f.rating} onChange={(e) => setF({ ...f, rating: e.target.value })} /></Field>
              <Field label="Loja"><Select testid="reply-store-select" value={f.store_id} onChange={(e) => setF({ ...f, store_id: e.target.value })} options={storeOpts} /></Field>
            </div>
            <Field label="Tom da resposta"><Segmented testid="reply-tone" options={TONES} value={f.tone} onChange={(v) => setF({ ...f, tone: v })} /></Field>
            <button data-testid="reply-generate-btn" onClick={gen} disabled={busy} className={`${btnPrimary} w-full`}>{busy && <Loader2 className="h-4 w-4 animate-spin" />} Gerar resposta</button>
          </div>
        </Panel>
        <Panel title="Resposta sugerida">
          {reply ? (
            <>
              <textarea data-testid="reply-output" rows={8} className={areaCls} value={reply} onChange={(e) => setReply(e.target.value)} />
              <p className="mt-1 text-right font-mono text-xs text-slate-500">{reply.length} caracteres</p>
              <button data-testid="reply-copy-btn" onClick={() => { navigator.clipboard.writeText(reply); toast.success("Resposta copiada"); }} className="mt-3 inline-flex h-12 items-center gap-2 rounded-lg bg-amber-500 px-6 font-extrabold text-white hover:bg-amber-600"><Copy className="h-5 w-5" /> COPIAR</button>
            </>
          ) : <p className="text-sm text-slate-400">A resposta gerada aparecerá aqui.</p>}
        </Panel>
      </div>
    </div>
  );
}
